import { createElement, memo, useContext } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import styles from './index.module.scss';
import Sensor from '@max/mbc-sensor';
import { GOODS_STATUS } from '../../types';
const isWeb = true;
import { useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import { navigateToDetailPage } from '../../utils/navigate';
import { LX_CONFIG } from '../../constants';
import CornerMark from '../CornerMark';
const fontSizeBoundary = 1999;
function ThreeColumnCard(props) {
    const { headImage, positionInfo, title, price, buyButtonText, status, extModel, angleImg, privilegeTag, buyButtonTextColor, posTagList, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, headIconBorderColor, salesCount, salesInfoSwitch } = props.poiInfo;
    const { poiIdList, poiIdUrlExtraParamsString, itemIndex, clickBizLine, isRecallRecommend = false, detailPageAnchor } = props;
    const { sellPrice, originalPrice, discountInfo } = price || {};
    const ctx = useContext(global?._EngineGlobalContext);
    const { monitorNavigateTo } = useMonitorNavigation();
    const { _LXReport, _moduleId } = ctx || {};
    const hasSaleCount = originalPrice && sellPrice && Number(originalPrice) > Number(sellPrice);
    const onCardClick = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        const shopuuid = extModel.shopUuid;
        if (!poiId || status !== GOODS_STATUS.CAN_SALE || window?.inEditor) {
            return;
        }
        const hotelchannel = ctx?._runtimeInfo?.queryParams?.hotelchannel;
        const val_lab = {
            _moduleId: _moduleId ?? '-999',
            poi_id: poiId,
            item_index: itemIndex,
            is_privilege: privilegeTag,
            is_ddt_label: Boolean(angleImg?.needTag),
            tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
            custom: {
                ...(hotelchannel ? {
                    hotel_channel: hotelchannel
                } : {}),
                ...(clickBizLine ? {
                    click_biz_line: clickBizLine
                } : {})
            }
        };
        _LXReport?.mcReportWithTag?.(LX_CONFIG.CARD_MC_BID, {
            valLab: val_lab
        });
        navigateToDetailPage({
            poiId,
            shopuuid,
            hotelchannel
        }, monitorNavigateTo, {
            isNeedAdd: Array.isArray(poiIdList) && poiIdList?.indexOf(poiId?.toString()) > -1,
            extraParamsString: poiIdUrlExtraParamsString,
            anchor: detailPageAnchor,
            externalParams: props.externalParams
        });
    };
    const onCardShow = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        _LXReport?.mvReport(LX_CONFIG.CARD_MV_BID, {
            valLab: {
                _moduleId: _moduleId ?? '-999',
                poi_id: poiId,
                item_index: itemIndex,
                is_privilege: privilegeTag,
                is_ddt_label: Boolean(angleImg?.needTag),
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999',
                    click_biz_line: clickBizLine ?? '-999'
                }
            }
        });
    };
    return <Sensor once onAppear={() => {
        onCardShow();
    }}>
      <View className={styles.threeColumnCard} style={{
        ...(isWeb ? {
            boxShadow: '0rpx 3rpx 9rpx 0rpx rgba(0, 0, 0, 0.12)'
        } : {})
    }} onClick={() => {
        onCardClick();
    }}>
        <View className={styles.threeColumnImageWrapper}>
          <Image x-if={headImage?.value} className={styles.threeColumnImage} source={{
        uri: headImage?.value ? headImage.value.replace('http:', 'https:').replace('/w.h/', '/') + '@684w' : ''
    }} borderRadius={0}/>

          <CornerMark angleImg={angleImg} posTagList={posTagList} headIcon={headIcon} headIconImg={headIconImg} headIconText={headIconText} showCornerMark={props.showCornerMark} headIconTextColor={headIconTextColor} headIconBackgroundColor={headIconBackgroundColor} headIconBorderColor={headIconBorderColor} isRecallRecommend={isRecallRecommend}/>
          <View x-if={positionInfo} className={styles.threeColumnLocationOverlay}>
            <View className={styles.threeColumnLocationIconWrapper}>
              <Image source={{
        uri: 'https://p0.meituan.net/ingee/dee934b5bbd3366f424f011758894a48308.png'
    }} style={{
        width: '17rpx',
        height: '21rpx'
    }}></Image>
            </View>
            <Text className={styles.threeColumnLocationText} numberOfLines={1}>
              {positionInfo}
            </Text>
          </View>
        </View>

        <View className={styles.threeColumnContent}>
          <Text className={styles.threeColumnName} numberOfLines={2}>
            {title}
          </Text>

          <View className={styles.threeColumnTags} style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }}>
            <View x-if={discountInfo} className={styles.threeColumnTagItem}><Text className={styles.threeColumnTagItemText}>{discountInfo}</Text></View>
            <View x-if={salesCount && salesInfoSwitch} className={styles.threeColumnTagItem}>
              <Text className={styles.threeColumnTagItemText}>{salesCount}</Text>
            </View>
          </View>

          <View className={styles.threeColumnBottom}>
            <View className={styles.threeColumnPriceWrapper}>
              <Text>
                  <Text className={styles.threeColumnPriceSymbol}>¥</Text>
                  <Text className={styles.threeColumnPrice} style={{
        fontSize: Number(sellPrice) > fontSizeBoundary ? '24rpx' : '34rpx'
    }}>{sellPrice}</Text>
                  <Text className={styles.threeColumnPriceQi}>起</Text>
              </Text>
              <Text x-if={hasSaleCount} className={styles.threeColumnOriginalPrice}>¥{originalPrice}</Text>
            </View>

            <LinearGradient colors={['#FF7700', '#FF4B10']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className={styles.threeColumnBuyButton}>
              <Text className={styles.threeColumnBuyText} style={{
        color: status === GOODS_STATUS.CAN_SALE ? buyButtonTextColor : '#999999'
    }}>
                {status === GOODS_STATUS.CAN_SALE ? buyButtonText : '售罄'}
              </Text>
            </LinearGradient>
          </View>
        </View>
      </View>
    </Sensor>;
}
export default memo(ThreeColumnCard);
